import {
  CollectionReference,
  Query,
  QueryDocumentSnapshot,
  QuerySnapshot,
} from "@atgof-firebase/types";
import { transformSnapshot, useSnapshot } from "./useSnapshot";
import _ from "lodash";

export function useDocuments(
  refOrQuery: CollectionReference | Query | undefined,
  queryDeps?: React.DependencyList,
) {
  return useSnapshot(
    transformSnapshot<QuerySnapshot, QueryDocumentSnapshot[]>(
      refOrQuery ? _.bind(refOrQuery.onSnapshot, refOrQuery) : undefined,
      ({ docs }) => docs,
    ),
    [
      refOrQuery && "path" in refOrQuery ? refOrQuery.path : undefined,
      ...(queryDeps ?? []),
    ],
  );
}
